/**
 * Created by jv on 15/05/2018.
 */
import CONSTANTS from "Sources/games/carrot-game/config/constants";

export default class Game extends Phaser.Scene
{
  constructor()
  {
    super({ key: "Game" });

    /**
     *  Keep the last high score registered.
     */
    this.highScore = 0;
  }

  init()
  {
    // https://github.com/photonstorm/phaser/issues/3185
    this.scene.launch("Track")
              .launch("Menu", { type: "pause-menu"})
              .launch("Scoreboard", { gameScene: this })
              .launch("GameOver", { gameScene: this });

    this.points = 0;
    this.paused = false;
    this.debug = CONSTANTS.DEBUG;

    this.speedIncreaseTimer = null;
  }

  create()
  {
    this.track = this.scene.get("Track");

    this.setSceneOrder();

    var gameWidth = this.sys.game.config.width;
    var gameHeight = this.sys.game.config.height;

    var grassHeight = this.scene.systems.game.textures.get("bg_track_grass").getSourceImage().height;
    var pathHeight = this.scene.systems.game.textures.get("bg_track_ground").getSourceImage().height;

    this.sky = this.add.tileSprite(0, 0, gameWidth, gameHeight, "bg_track_sky").setOrigin(0, 0);
    this.clouds = this.add.tileSprite(0, 0, gameWidth, this.scene.systems.game.textures.get("bg_track_clouds").getSourceImage().height, "bg_track_clouds").setOrigin(0, 0);
    this.mountains = this.add.tileSprite(0, gameHeight - pathHeight - 185, gameWidth, this.scene.systems.game.textures.get("bg_track_mountain").getSourceImage().height, "bg_track_mountain").setOrigin(0, 0);
    this.grass = this.add.tileSprite(0, gameHeight - pathHeight - grassHeight + 1, gameWidth, grassHeight, "bg_track_grass").setOrigin(0, 0);
    this.path = this.add.tileSprite(0, gameHeight - pathHeight, gameWidth, pathHeight, "bg_track_ground").setOrigin(0, 0);

    // Set up input
    this.setUpInput();

    this.track.events.off("carrot-taken").on("carrot-taken", this.carrotTaken, this)
                     .off("rabbit-collided").on("rabbit-collided", this.rabbitCollided, this);

    // Speed increase loop (start increasing speed every 10 seconds AFTER 30 seconds)
    this.setUpSpeedIncreaseTimer();

    if(this.debug)
    {
      this._debugText = this.add.text(100, 20);
      this._debugText.setShadow(1, 1, "#000000", true, false)
    }
  }

  setSceneOrder()
  {
    this.scene.moveAbove("Game", "Scoreboard");
    this.scene.moveAbove("Scoreboard", "Track");
    this.scene.moveAbove("Track", "Menu");
    this.scene.moveAbove("Menu", "GameOver");
  }

  setUpInput()
  {
    this.cursors = this.input.keyboard.addKeys({
      upKey: Phaser.Input.Keyboard.KeyCodes.UP
    });
    this.spaceKey = this.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.SPACE);

    this.input.off("pointerdown").on("pointerdown", (e) =>
    {
      if(!this.paused)
      {
        this.clickJump = true;
        // this.track.updateInput({ cursors: this.cursors, spaceKey: this.spaceKey, pointerDown: true });
      }
    }, this);
  }

  setUpSpeedIncreaseTimer()
  {
    this.speedIncreaseTimer = this.time.delayedCall(30000, () =>
    {
      // this.track.trackSpeed += 0.5;
      this.track.trackSpeed += 0.03;

      this.speedIncreaseTimer = this.time.addEvent({ delay: 10000, callback: () =>
      {
        // this.track.trackSpeed += 0.5;
        this.track.trackSpeed += 0.03;
      }, callbackScope: this, loop: true });
    });
  }

  update(time, delta)
  {
    this._updateDebugText();

    if(this.track.rabbit.alive && !this.paused)
    {
      this.updateBackground(time, delta);
      this.track.updateInput({ cursors: this.cursors, spaceKey: this.spaceKey, pointerDown: this.clickJump });
      this.clickJump = false;
      this.updateLogic(time);
    }
  }

  updateBackground(time, delta)
  {
    // console.log(delta);

    var speed = delta * this.track.trackSpeed;

    // this.sky.tilePositionX += this.track.trackSpeed / 15;
    // this.clouds.tilePositionX += this.track.trackSpeed / 8;
    // this.mountains.tilePositionX += this.track.trackSpeed / 6;
    // this.grass.tilePositionX += this.track.trackSpeed / 4;
    // this.path.tilePositionX += this.track.trackSpeed;

    // console.log(speed);

    this.sky.tilePositionX += speed / 15;
    this.clouds.tilePositionX += speed / 8;
    this.mountains.tilePositionX += speed / 6;
    this.grass.tilePositionX += speed / 4;
    this.path.tilePositionX += speed;
  }

  updateLogic(time)
  {
    if(!this.track.rabbit.alive)
    {
      this.endGame();
    }

    if(this.track.rabbit.powerUp !== null)
    {
      this.track.rabbit.attractPowerUp();
    }
  }

  endGame()
  {
    //  Update the high score.
    this.highScore = Math.max(this.points, this.highScore);

    this.scene.get("Scoreboard").setHelpButtonInteractive(false);

    this.pause();

    this.time.delayedCall(1000, () =>
    {
      this.track.clearTrack();
      this.events.emit("game-end");
    });
  }

  restart()
  {
    this.scene.stop("Track")
              .stop("Scoreboard")
              .stop("Menu")
              .stop("GameOver")
              .start("Game");
  }

  resume()
  {
    this.paused = false;

    if(this.speedIncreaseTimer !== null)
    {
      this.speedIncreaseTimer.paused = false;
    }

    this.scene.get("Track").paused = false;
  }

  pause()
  {
    this.paused = true;

    if(this.speedIncreaseTimer !== null)
    {
      this.speedIncreaseTimer.paused = true;
    }

    this.scene.get("Track").paused = true;
  }

  togglePause()
  {
    if(this.paused)
    {
      this.resume();
    }
    else
    {
      this.pause();
    }
  }

  carrotTaken(carrot)
  {
    this.points += carrot.doubleValue ? 2 : 1
    this.events.emit("points-updated", this.points);
  }

  rabbitCollided()
  {
    this.endGame()
  }

  _updateDebugText()
  {
    if(this.debug)
    {
      var textContent = [];

      textContent.push("HighScore: " + this.highScore);
      textContent.push("Alive: " + this.track.rabbit.alive);
      textContent.push("Missed (c | o | p): " + this.track.carrotsMissed + " | " + this.track.obstaclesAvoided + " | " + this.track.powerUpsMissed);
      var powerUp = "/"
      if(typeof this.track.rabbit.powerUp !== "undefined" && this.track.rabbit.powerUp !== null)
      {
        powerUp = this.track.rabbit.powerUp.type
        if(this.track.powerUpTimer !== null)
        {
          var timeRemaining = Math.round(this.track.powerUpTimer.delay / 1000) -  Math.round(this.track.powerUpTimer.getElapsedSeconds());
          powerUp += " (" + timeRemaining + "s)";
        }
      }
      textContent.push("PowerUp: " + powerUp);
      textContent.push("Trackspeed: " + this.track.trackSpeed);
      var timeTillNextSpeedIncrease = "/";
      if(typeof this.speedIncreaseTimer !== "undefined" && this.speedIncreaseTimer !== null)
      {
        timeTillNextSpeedIncrease = Math.round(this.speedIncreaseTimer.delay / 1000) -  Math.round(this.speedIncreaseTimer.getElapsedSeconds());
      }
      textContent.push("Time until next speed increase: " + timeTillNextSpeedIncrease + "s");

      var timeTillCarrotSpawn = "/";
      var timeTillObstacleSpawn = "/";
      var timeTillPowerUpSpawn = "/";

      if(typeof this.track.carrotSpawnTimer !== "undefined" && this.track.carrotSpawnTimer !== null)
      {
        timeTillCarrotSpawn = Math.round(this.track.carrotSpawnTimer.delay -  this.track.carrotSpawnTimer.getElapsed());
      }
      if(typeof this.track.obstacleSpawnTimer !== "undefined" && this.track.obstacleSpawnTimer !== null)
      {
        timeTillObstacleSpawn = Math.round(this.track.obstacleSpawnTimer.delay -  this.track.obstacleSpawnTimer.getElapsed());
      }
      if(typeof this.track.powerUpSpawnTimer !== "undefined" && this.track.powerUpSpawnTimer !== null)
      {
        timeTillPowerUpSpawn = Math.round(this.track.powerUpSpawnTimer.delay / 1000) -  Math.round(this.track.powerUpSpawnTimer.getElapsedSeconds());
      }

      textContent.push("Next spawn (c | o | p): " +  timeTillCarrotSpawn + "ms | " + timeTillObstacleSpawn + "ms | " + timeTillPowerUpSpawn + "s");

      this._debugText.setText(textContent);
    }
  }
}



// WEBPACK FOOTER //
// ./app/js/games/carrot-game/scenes/game.js